import {Component, Input, OnInit} from '@angular/core';
import {DatePipe, KeyValue} from '@angular/common';
import {ActivatedRoute} from '@angular/router';
import {Platform} from '@angular/cdk/platform';
import {CommonService} from '../../@shared/services/common.service';
import {BookingService} from '../../@shared/new-services/booking.service';


@Component({
    selector: 'app-tracking-standalone-vertical',
    templateUrl: './tracking-standalone-vertical.component.html',
    styleUrls: ['./tracking-standalone-vertical.component.scss']
})
export class TrackingStandaloneVerticalComponent implements OnInit {

    trackingId: string;
    tempTrackingId: string;
    trackingDetails: any = null;
    isLoading = false;
    trackingDetailsArray: any[] = [];
    isTracked = false;
    isError = false;
    screenSize = window.innerWidth;
    @Input() publicTracking = false;
    shipmentType: any;

    constructor(private commonService: CommonService, private activatedRoute: ActivatedRoute, public platform: Platform,
                private bookingService: BookingService) {
    }

    originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
        return 0;
    }

    ngOnInit(): void {
        // this.getShipmentTracking('O210905831');
        this.activatedRoute.queryParams.subscribe((param: any) => {
            if (param?.trackingId) {
                this.getShipmentTracking(param?.trackingId);
                this.trackingId = param.trackingId;
            }
        });
    }

    getShipmentTracking(trackingID: string) {
        this.trackingDetails = null;
        this.isTracked = true;
        this.isLoading = true;
        this.isError = false;
        this.bookingService
            .getTrackingByBookingId(trackingID)
            .subscribe(
                (x) => {
                    this.isLoading = false;
                    this.shipmentType = x?.shipmentTrackingVO?.shipmentType;
                    this.trackingDetailsArray = [];
                    x.trackingDetailsHeader = this.buildTrackingDetailsHeader(x?.shipmentTrackingVO, this.shipmentType);
                    x?.shipmentTrackingVO?.shipmentTrackingStatusVOList?.map(
                        (tracking) => {
                            const datePipe = new DatePipe('en-US');
                            tracking.statusDateTime = datePipe.transform(tracking.statusDateTime, 'dd-MMM-yyyy h:mm a');
                            if (tracking?.enabled) {
                                this.trackingDetailsArray.push(tracking);
                                if (tracking?.status === 'Booking Created' || tracking?.status === 'Initiated') {
                                    tracking.icon = 'booking-created';
                                }
                                if (tracking?.status === 'Booking Confirmed' || tracking?.status === 'Cargo Carted') {
                                    tracking.icon = 'booking-confirmed';
                                }
                                if (tracking?.status === 'In Progress') {
                                    tracking.icon = 'in-progress';
                                }
                                if (tracking?.status === 'Customs Cleared' || tracking?.status === 'Custom Clearance Complete' ||
                                    tracking?.status === 'Completed') {
                                    tracking.icon = 'customs-cleared';
                                }
                                if (tracking?.status === 'Truck Placed') {
                                    tracking.icon = 'truck-dispatched';

                                }
                                if (tracking?.status === 'Truck Dispatched') {
                                    tracking.icon = 'truck-placed';
                                }
                                if (tracking?.status === 'Cargo Stuffed') {
                                    tracking.icon = 'cargo-stuffed';
                                }

                                if (tracking?.status === 'Shipment Planned' || tracking?.status === 'Document Received') {
                                    tracking.icon = 'shipment-planned';
                                }
                                if (tracking?.status === 'Shipment Sailed' || tracking?.status === 'Shipment Departed') {
                                    tracking.icon = 'sailed';
                                }
                                if (tracking?.status === 'Shipment Arrived') {
                                    tracking.icon = 'arrived';
                                }
                                if (tracking?.status === 'Shipment Delivered' || tracking?.status === 'Delivered') {
                                    tracking.icon = 'delivered';
                                }
                                if (tracking?.status === 'Cancelled') {
                                    tracking.icon = 'cancelled';
                                }
                            }
                        }
                    );
                    this.trackingDetails = x;
                }, (error) => {
                    this.isError = true;
                    this.isLoading = false;
                    console.log(error);
                }
            );
    }


    getPublicTracking(trackingID: string) {
        this.trackingId = trackingID;
        this.trackingDetails = null;
        this.isTracked = true;
        this.isLoading = true;
        this.isError = false;
        this.bookingService
            .getPublicTrackingByTrackingId(trackingID)
            .subscribe(
                (x) => {
                    this.isLoading = false;
                    this.shipmentType = x?.shipmentTrackingVO?.shipmentType;
                    this.trackingDetailsArray = [];
                    x.trackingDetailsHeader = this.buildTrackingDetailsHeader(x?.shipmentTrackingVO, this.shipmentType);
                    x?.shipmentTrackingVO?.shipmentTrackingStatusVOList?.map(
                        (tracking) => {
                            const datePipe = new DatePipe('en-US');
                            tracking.statusDateTime = datePipe.transform(tracking.statusDateTime, 'dd-MMM-yyyy h:mm a');
                            if (tracking?.enabled) {
                                this.trackingDetailsArray.push(tracking);
                                if (tracking?.status === 'Booking Created' || tracking?.status === 'Initiated') {
                                    tracking.icon = 'booking-created';
                                }
                                if (tracking?.status === 'Booking Confirmed' || tracking?.status === 'Cargo Carted') {
                                    tracking.icon = 'booking-confirmed';
                                }
                                if (tracking?.status === 'In Progress') {
                                    tracking.icon = 'in-progress';
                                }
                                if (tracking?.status === 'Customs Cleared' || tracking?.status === 'Custom Clearance Complete' ||
                                    tracking?.status === 'Completed') {
                                    tracking.icon = 'customs-cleared';
                                }
                                if (tracking?.status === 'Truck Placed') {
                                    tracking.icon = 'truck-dispatched';

                                }
                                if (tracking?.status === 'Truck Dispatched') {
                                    tracking.icon = 'truck-placed';
                                }
                                if (tracking?.status === 'Cargo Stuffed') {
                                    tracking.icon = 'cargo-stuffed';
                                }

                                if (tracking?.status === 'Shipment Planned' || tracking?.status === 'Document Received') {
                                    tracking.icon = 'shipment-planned';
                                }
                                if (tracking?.status === 'Shipment Sailed' || tracking?.status === 'Shipment Departed') {
                                    tracking.icon = 'sailed';
                                }
                                if (tracking?.status === 'Shipment Arrived') {
                                    tracking.icon = 'arrived';
                                }
                                if (tracking?.status === 'Shipment Delivered' || tracking?.status === 'Delivered') {
                                    tracking.icon = 'delivered';
                                }
                                if (tracking?.status === 'Cancelled') {
                                    tracking.icon = 'cancelled';
                                }
                            }
                        }
                    );
                    this.trackingDetails = x;
                }, (error) => {
                    this.isError = true;
                    this.isLoading = false;
                    console.log(error);
                }
            );
    }

    searchTrackingUsingTrackingId(event: any) {
        const trackingId = event.target.value;
        this.tempTrackingId = trackingId;
    }

    onClickOfTrack() {
        this.trackingId = this.tempTrackingId;
        if (this.publicTracking) {
            this.getPublicTracking(this.trackingId);
        } else {
            this.getShipmentTracking(this.trackingId);
        }
    }

    buildTrackingDetailsHeader(shipmentTrackingVO: any, shipmentType: any) {
        const datePipe = new DatePipe('en-US');
        if (shipmentType === 'FCL' || shipmentType === 'LCL'
            || shipmentType === 'Transport' || shipmentType === 'Custom Clearance' || shipmentType === 'Service Job') {
            const trackingHeaderDetails =
                {
                    'Booking Number': shipmentTrackingVO?.bookingNumber,
                    'Customer Ref No.': shipmentTrackingVO?.customerReferenceNumber,
                    Vessel: shipmentTrackingVO?.vesselName,
                    Voyage: shipmentTrackingVO?.voyage,
                    'Place of Receipt': shipmentTrackingVO?.placeOfReceipt,
                    'Port of Loading': shipmentTrackingVO?.portOfLoading,
                    'Port of Discharge': shipmentTrackingVO?.portOfDischarge,
                    'Final Place of Delivery': shipmentTrackingVO?.finalPlaceOfDelivery,
                    'Transit Duration': shipmentTrackingVO?.transitDuration ? (shipmentTrackingVO?.transitDuration + ' Days') : '-',
                    'No. of Containers': shipmentTrackingVO?.numberOfContainers,
                };
            if (shipmentType === 'LCL') {
                trackingHeaderDetails['HBL/FCR Number'] = shipmentTrackingVO?.fcrOrHblNumber;
                trackingHeaderDetails['MBL Number'] = shipmentTrackingVO?.mblNumber;
            } else {
                trackingHeaderDetails['HBL Number'] = shipmentTrackingVO?.hblNumber;
                trackingHeaderDetails['MBL Number'] = shipmentTrackingVO?.mblNumber;
            }
            return trackingHeaderDetails;
        }
        if (shipmentType === 'AIR') {
            const trackingHeaderDetails =
                {
                    'Booking Number': shipmentTrackingVO?.bookingNumber,
                    'HAWB Number': shipmentTrackingVO?.hawbNumber,
                    'MAWB Number': shipmentTrackingVO?.mawbNumber,
                    'Customer Ref No.': shipmentTrackingVO?.customerReferenceNumber,
                    'Gross Weight': shipmentTrackingVO?.grossWeight + ' ' + shipmentTrackingVO?.grossWeightUOM,
                    'Transit Duration': shipmentTrackingVO?.transitDuration ? (shipmentTrackingVO?.transitDuration + ' Days') : '',
                    'Flight No 1': shipmentTrackingVO?.flightNo1,
                    'Flight No 2': shipmentTrackingVO?.flightNo2,
                    'Chargeable Weight(KG)': shipmentTrackingVO?.chargeableWeight,
                    Airline: shipmentTrackingVO?.airline,
                    // 'Airport of Loading': shipmentTrackingVO?.origin,
                    // 'Airport of Discharge': shipmentTrackingVO?.destination,
                    Origin: shipmentTrackingVO?.origin,
                    Destination: shipmentTrackingVO?.destination,

                };
            return trackingHeaderDetails;
        }

    }
}
